var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import 'simplebar/dist/simplebar.min.css';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { forwardRef, useEffect, useRef } from 'react';
import SimplebarCore from 'simplebar/dist/simplebar-core.esm';
const Scrollbar = forwardRef((props, ref) => {
    const elRef = useRef(null);
    const contentNodeRef = useRef(null);
    const scrollableNodeRef = useRef(null);
    const { children, onScroll } = props, rest = __rest(props, ["children", "onScroll"]);
    const instanceRef = useRef(null);
    const options = {
        autoHide: false,
        scrollbarMinSize: 80,
    };
    const otherProps = {};
    Object.keys(rest).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(SimplebarCore.defaultOptions, key)) {
            options[key] = rest[key];
        }
        else {
            otherProps[key] = rest[key];
        }
    });
    useEffect(() => {
        if (elRef.current) {
            instanceRef.current = new SimplebarCore(elRef.current, Object.assign(Object.assign(Object.assign({}, options), (scrollableNodeRef.current && {
                scrollableNode: scrollableNodeRef.current,
            })), (contentNodeRef.current && {
                contentNode: contentNodeRef.current,
            })));
            if (ref && typeof ref !== 'function') {
                ref.current = instanceRef.current;
            }
            if (onScroll) {
                instanceRef.current.getScrollElement().addEventListener('scroll', onScroll);
            }
        }
        return () => {
            if (instanceRef.current) {
                if (onScroll) {
                    instanceRef.current.getScrollElement().removeEventListener('scroll', onScroll);
                }
                instanceRef.current.unMount();
                instanceRef.current = null;
            }
        };
    }, []);
    return (React.createElement(Box, Object.assign({ ref: elRef, className: 'simplebar-container', "data-simplebar": true, sx: (theme) => ({
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            '.simplebar-vertical': {
                right: '0',
                width: theme.spacing(2),
            },
            '.simplebar-content': {
                minHeight: '100%',
            },
            '.simplebar-scrollbar': {
                '&:before': {
                    right: '1px',
                    top: '1px',
                    bottom: '1px',
                    backgroundColor: alpha(theme.palette.grey[500], 0.12),
                },
                '&.simplebar-hover:before': {
                    backgroundColor: alpha(theme.palette.grey[500], 0.32),
                },
                '&.simplebar-visible:before': {
                    opacity: '1',
                },
            },
            '.simplebar-track': {
                '&.simplebar-vertical': {
                    width: '13px',
                },
                '&.simplebar-horizontal': {
                    height: '13px',
                    '.simplebar-scrollbar': {
                        top: '1px',
                        height: '10px',
                    },
                },
            },
        }) }, otherProps),
        React.createElement("div", { className: 'simplebar-wrapper' },
            React.createElement("div", { className: 'simplebar-height-auto-observer-wrapper' },
                React.createElement("div", { className: 'simplebar-height-auto-observer' })),
            React.createElement("div", { className: 'simplebar-mask' },
                React.createElement("div", { className: 'simplebar-offset' },
                    typeof children === 'function' && children({ scrollableNodeRef, contentNodeRef }),
                    typeof children !== 'function' && (React.createElement("div", { className: 'simplebar-content-wrapper', ref: scrollableNodeRef },
                        React.createElement("div", { className: 'simplebar-content', ref: contentNodeRef }, children))))),
            React.createElement("div", { className: 'simplebar-placeholder' })),
        React.createElement("div", { className: 'simplebar-track simplebar-horizontal' },
            React.createElement("div", { className: 'simplebar-scrollbar' })),
        React.createElement("div", { className: 'simplebar-track simplebar-vertical' },
            React.createElement("div", { className: 'simplebar-scrollbar' }))));
});
Scrollbar.displayName = 'Scrollbar';
export default Scrollbar;
